import ELearningHeader from './ElearningHeader.vue';
import ELearningHome from './ElearningHome';
import ELSession from './ElearningSession.vue';
import ELResult from './ElearningResult.vue';
import index from './index';
import moduleId from './moduleId';
import constants from './constants';
import store from '@/store/index';
import i18n from '@/plugins/i18n';
const { ROUTES } = constants;
class ELearningRouteHandler {
  getRoutes = ({ moduleType }) => {
    return [
      {
        path: `/${index.path}/:instance`,
        name: ROUTES.HOME,
        // hideToolbar would avoid rendering dialogs -> so, wont work
        meta: {
          moduleType,
          initiateSyncBeforeNav: true,
          moduleId,
          baseRoute: true,
          transitionName: 'slide',
          isRouterViewFixed: true,
        },
        components: { default: ELearningHome, header: ELearningHeader },
      },
      {
        path: `/${index.path}/training/:instance/:moduleId/result`,
        name: ROUTES.TRAINING_RESULT,
        meta: {
          moduleType,
          initiateSyncBeforeNav: false,
          moduleId,
          baseRoute: true,
          transitionName: 'slide',
          isRouterViewFixed: true,
        },
        components: { default: ELResult, header: ELearningHeader },
      },
      {
        path: `/${index.path}/training/:instance/:moduleId/:slideIndex`,
        name: ROUTES.TRAINING,
        meta: {
          moduleType,
          initiateSyncBeforeNav: false,
          moduleId,
          baseRoute: true,
          transitionName: 'slide',
          isRouterViewFixed: true,
        },
        components: { default: ELSession, header: ELearningHeader },
      },
      {
        path: `/${index.path}/exam/:instance/:moduleId/result`,
        name: ROUTES.EXAM_RESULT,
        meta: {
          moduleType,
          initiateSyncBeforeNav: false,
          moduleId,
          dbaseRoute: true,
          transitionName: 'slide',
          isRouterViewFixed: true,
        },
        components: { default: ELResult, header: ELearningHeader },
      },
      {
        path: `/${index.path}/exam/:instance/:moduleId/:slideIndex`,
        name: ROUTES.EXAM,
        meta: {
          moduleType,
          initiateSyncBeforeNav: false,
          moduleId,
          dbaseRoute: true,
          transitionName: 'slide',
          isRouterViewFixed: true,
        },
        components: { default: ELSession, header: ELearningHeader },
      },
    ];
  };

  /**
   * Optional method called in beforeEach
   * @param {object} moduleState the vuex state of the current module
   * @param {object} moduleConfig the module configuration where the user tries to navigate to
   * @param {object} from previous route
   * @param {object} to next route
   * @param {function} next function provided by vue router. Can be called to continue at a later stage.
   * @returns {{shouldContinue: boolean}} when shouldContinue is true, the router navigates to the next route (=to)
   */
  beforeNavigationFrom({ moduleState, moduleConfig, from, to, next }) {
    console.debug('elearning beforeNavigation moduleState=', moduleState);
    let elModule = moduleState.modulesById[Number(from.params.moduleId)];
    console.debug('module', JSON.stringify(elModule, null, 2));
    let shouldContinue = true;

    if (to.name === from.name) {
      let toPathSegments = to.fullPath.split('/');
      toPathSegments.pop();
      let newToPath = toPathSegments.join('/');

      let fromPathSegments = from.fullPath.split('/');
      fromPathSegments.pop();
      let newFromPath = fromPathSegments.join('/');

      if (newToPath === newFromPath) {
        // Paths are equal (excluding the last segment)
        shouldContinue = true;
      }
      // TODO else ?!
    } else if (from.name === ROUTES.EXAM) {
      let userState = moduleState.userStateByModuleId[from.params.moduleId];

      console.debug('navigate from exam, userState', JSON.stringify(userState, null, 2));
      // do not allow navigate away if not finished
      if (to.name === ROUTES.EXAM_RESULT) {
        shouldContinue = true;
      } else if (userState.status !== constants.STATUS.finished) {
        if (elModule.timeout === 0) {
          store.commit('elearning/setDialog', {
            id: 'interruptExamWithNoTimeout',
            isOpen: true,
            title: i18n.t('el.examInterruptAllowedTitle'),
            text: i18n.t('el.examInterruptAllowedText'),
            okText: i18n.t('label.ok'),
            cancelText: i18n.t('label.no'),
            next,
            params: { module: elModule },
          });
          shouldContinue = false;
        } else {
          store.commit('elearning/setDialog', {
            id: 'interruptExam', // dialog id that is provided with callbacks
            isOpen: true, // true=open
            title: i18n.t('el.examInterruptNotAllowedTitle'), // dialog title
            text: i18n.t('el.examInterruptNotAllowedText'), // dialog content
            okText: i18n.t('label.ok'), //text for ok button
            next,
            params: { module: elModule },
          });
          shouldContinue = false;
        }
      }
    } else if (from.name === ROUTES.TRAINING) {
      let moduleUserState = moduleState.userStateByModuleId[from.params.moduleId];

      // Display dialog when not in status finished
      if (moduleUserState.status !== constants.STATUS.finished) {
        store.commit('elearning/setDialog', {
          id: 'interruptTraining', // dialog id that is provided with callbacks
          isOpen: true, // true=open
          title: i18n.t('el.trainingInterruptTitle'), // dialog title
          text: i18n.t('el.trainingInterruptText'), // dialog content
          okText: i18n.t('label.yes'), //text for ok button
          cancelText: i18n.t('label.no'), //text for ok button
          next,
          params: { module: elModule },
        });

        shouldContinue = false;
      }
    }

    return { shouldContinue };
  }
}
const routeHandler = new ELearningRouteHandler();
export default routeHandler;
